jQuery(document).on('change', '.file-upload input[type=file]', function(){
    var file = jQuery(this).val().split('\\').pop();
    jQuery(this).closest('.file-upload').find('.gfield_description').html(file);
});
jQuery(document).bind('gform_post_render', function(){
   if(jQuery('.file-upload .ginput_preview').length){
       var file = jQuery('.file-upload .ginput_preview strong').text();
       jQuery('.file-upload .gfield_description').html(file);
   }
});

jQuery(document).ready(function () {
    jQuery('.datepicker').attr('readonly', '');

    var scrollHeight;
    jQuery('.form-popup-trigger').click(function (e) {
        e.preventDefault();
        var $this = jQuery(this);
        var formId = jQuery(this).attr('data-formid');
        $this.parent().find('form').remove();
        scrollHeight = launchPopup(formId, $this);
    });

    jQuery('.form-popup-close, .form-popup-overlay').click(function () {
        var $popup = jQuery(this).closest('.form-popup');
        $popup.removeClass('active').removeClass('open');
        setTimeout(function () {
            $popup.css('display', 'none');
            $popup.find('.form-container').css('display', 'none');
        }, 400);
        enableScroll();
    });

    if (jQuery(document).width() > 640) {
        jQuery('.form-container-with-scrollbar').scroll(function (e) {
            var scrollPosition = jQuery(this).scrollTop();
            var scrolled = scrollPosition / scrollHeight;
            var pxToScroll = scrolled * jQuery('.form-popup.active .fake-scrollbar').height();
            pxToScroll = pxToScroll - (scrolled * jQuery('.form-popup.active .fake-scrollbar .bar').height());
            jQuery(".form-popup.active .fake-scrollbar").css('opacity', '1');
            jQuery(".form-popup.active .fake-scrollbar .bar").css('top', pxToScroll + 'px');
            clearTimeout(jQuery.data(this, 'scrollTimer'));
            jQuery.data(this, 'scrollTimer', setTimeout(function () {
                jQuery(".form-popup.active .fake-scrollbar").css('opacity', '0.25');
            }, 750));
        });
    }
});

function launchPopup(formId, $this) {
    var scrollHeight;
    var $popup = jQuery('div[data-formid="' + formId + '"]');
    $popup.css('display', 'flex');
    $popup.find('.form-container').css('display', 'block');
    $popup.addClass('open');
    scrollHeight = jQuery('.form-popup.open .form-container-with-scrollbar .gform_wrapper').height() - jQuery('.form-popup.open .form-container-with-scrollbar').height();
    setTimeout(function () {
        $popup.addClass('active');
        if (scrollHeight < 1) {
            jQuery('.form-popup.active .fake-scrollbar').css('opacity', '0');
            $popup.find('.form-container').css({'min-height': jQuery('.form-popup.active .form-container-with-scrollbar').height() + 'px', 'height': (jQuery('.form-popup.active .form-container-with-scrollbar').height() + 124) + 'px'});
        }
    }, 10);
    disableScroll();
    return scrollHeight;
}
